import { ofType, combineEpics } from "redux-observable";
import { mergeMap, catchError, switchMap, tap, ignoreElements } from "rxjs/operators";
import DetailsViewActions from "../ducks/DetailsViewActions.js";
import { Observable, of, from } from "rxjs";
import detailsViewActionTypes from "../ducks/DetailsViewActionTypes.js";
import ExperimentResources from "@ane/exp-data/lib/resources/ExperimentResources";
import "rxjs-compat";
import ExperimentReadV2Resource from "@ane/exp-data/lib/resources/ExperimentReadV2Resource";
import { ExperimentUtilsInstance } from "../../utils/ExperimentUtils.js";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import { loadQualityAlerts, loadOperationChecks } from "@ane/expalert/lib/module/views/Alert/ducks/AlertActions";
import { EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER } from "@ane/exp-data/lib/constants/ReducerConstants";
import ExperimentUtils from "../utils/ExperimentUtils.js";
import { experimentActionTypes, loadedExperiment } from "../ducks/Experiment.ducks.js";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import { loadAssignmentDetailsForExperimentEpicReducer } from "@ane/exp-data/lib/assignmentDetailsV2/epics";
const loadAssignmentDetailsAction = (payload) => loadAssignmentDetailsForExperimentEpicReducer.actionCreators.load(payload);
const experimentDataEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.GET_EXP_DATA),
    mergeMap((value) => {
      return Observable.fromPromise(ExperimentReadV2Resource.getExperiment(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.parseExperimentData(
                value.id,
                // @ts-ignore
                null,
                (_b = (_a = result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error when getting Experiment V2 Dto"
              )
            );
          }
          if (result2.statusCode === 301) {
            return of(
              DetailsViewActions.parseExperimentData(value.id, result2.getSuccessData(), void 0, result2.errorContext)
            );
          }
          const experimentResult = result2.getSuccessData();
          const experimentationGroup = getExperimentationGroupIdFromPath(
            // @ts-ignore
            experimentResult.WorkspaceId,
            experimentResult.ManagementGroup
          );
          const getMdsData = Observable.forkJoin(
            MdsDataplaneResources.getConfigWithType({
              // @ts-ignore
              workspaceId: experimentResult.WorkspaceId,
              experimentationGroup,
              section: MasterDataConstants.experimentTrafficFiltersSection
            }),
            MdsDataplaneResources.getConfigWithType({
              // @ts-ignore
              workspaceId: experimentResult.WorkspaceId,
              experimentationGroup,
              section: MasterDataConstants.experimentTemplates
            })
          ).map(([mdsFilters, mdsExperimentTemplates]) => {
            var parsedExperiment = ExperimentUtilsInstance.parseExperimentV2Dto(
              experimentResult,
              // @ts-ignore
              mdsFilters,
              mdsExperimentTemplates
            );
            return DetailsViewActions.parseExperimentData(value.id, parsedExperiment, null);
          }).catch((error) => of(DetailsViewActions.parseExperimentData(value.id, null, error)));
          return getMdsData;
        }),
        // @ts-ignore
        catchError((error) => of(DetailsViewActions.parseExperimentData(value.id, null, error)))
      );
    })
  );
};
const loadExperiment = (action$) => {
  return action$.pipe(
    ofType(experimentActionTypes.LOAD_EXPERIMENT),
    mergeMap((payload) => {
      const { id } = payload;
      return Observable.fromPromise(ExperimentResources.getExperiment(id)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              loadedExperiment(id, null, (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error when loading experiment", result2)
            );
          }
          const experimentResult = result2.getSuccessData();
          return Observable.of(loadedExperiment(id, experimentResult, null, result2));
        }),
        // @ts-ignore
        catchError((error) => of(loadedExperiment(id, null, error, result)))
      );
    })
  );
};
const experimentScorecardEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.GET_EXP_SCORECARDS),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.getExperimentScorecards(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.parseExperimentScorecards(
                value.id,
                [],
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error while getting scorecard data"
              )
            );
          }
          return Observable.of(DetailsViewActions.parseExperimentScorecards(value.id, result2.getSuccessData(), null));
        }),
        catchError((error) => of(DetailsViewActions.parseExperimentScorecards(value.id, [], error)))
      );
    })
  );
};
const experimentLogEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.GET_EXP_LOG),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.getExperimentJournals(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.parseExperimentLog(
                value.id,
                [],
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error while getting experiment log"
              )
            );
          }
          return Observable.of(DetailsViewActions.parseExperimentLog(value.id, result2.getSuccessData(), null));
        }),
        catchError((error) => of(DetailsViewActions.parseExperimentLog(value.id, [], error)))
      );
    })
  );
};
const experimentIterationsEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.GET_EXP_ITERS),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.getRelatedExperiments(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.parseExperimentIterations(
                value.id,
                [],
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error while getting experiment iterations"
              )
            );
          }
          return Observable.of(DetailsViewActions.parseExperimentIterations(value.id, result2.getSuccessData(), null));
        }),
        catchError((error) => of(DetailsViewActions.parseExperimentIterations(value.id, [], error)))
      );
    })
  );
};
const experimentOperationsEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.GET_EXP_OPS),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.getOperationChecksForExperiment(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.parseOperationsStatus(
                value.id,
                // @ts-ignore
                null,
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error while getting operation status"
              )
            );
          }
          return Observable.of(DetailsViewActions.parseOperationsStatus(value.id, result2.getSuccessData(), void 0));
        }),
        // @ts-ignore
        catchError((error) => of(DetailsViewActions.parseOperationsStatus(value.id, null, error.message)))
      );
    })
  );
};
const experimentStartEpic = (action$, state$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.INIT_START_EXP),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.startExperiment(value.id, false, value.additionalDetails)).pipe(
        mergeMap((result2) => {
          var _a, _b, _c, _d;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.finishStartExperiment(
                value.id,
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error in starting the experiment"
              )
            );
          }
          return Observable.of(
            DetailsViewActions.finishStartExperiment(value.id, void 0),
            DetailsViewActions.getOperationsStatus(value.id),
            loadAssignmentDetailsAction({
              workspaceId: ((_d = (_c = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _c.data) == null ? void 0 : _d.workspaceId) || "",
              experimentId: value.id
            })
          );
        }),
        catchError((error) => Observable.of(DetailsViewActions.finishStartExperiment(value.id, error)))
      );
    })
  );
};
const experimentIterateEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.INIT_ITERATE_EXP),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.cloneExperiment(value.id, value.additionalDetails)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.finishIteratexperiment(
                value.id,
                "",
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error while iterating the experiment"
              )
            );
          }
          value.additionalDetails.onSuccess();
          return Observable.of(DetailsViewActions.finishIteratexperiment(value.id, result2.getSuccessData(), null));
        }),
        catchError((error) => of(DetailsViewActions.finishIteratexperiment(value.id, "", error)))
      );
    })
  );
};
const finishIterateEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.FINISH_ITERATE_EXP),
    tap((action) => {
      if (!action.error) {
        ExperimentUtils.redirectToNewExperiment(action.payload);
      }
    }),
    ignoreElements()
  );
};
const finishUpdateEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.FINISH_UPDATE_EXP_DETAILS),
    tap((action) => {
      if (!action.error) {
        ExperimentUtils.redirectToNewExperiment(action.id);
      }
    }),
    ignoreElements()
  );
};
const experimentAdvanceDiffEpic = (action$, state$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.GET_EXP_ADV_DIFF),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.getAdvanceExperimentEffect(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b, _c, _d;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.parseExperimentAdvanceEffect(
                value.id,
                null,
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error while getting advancing changes"
              )
            );
          }
          return Observable.of(
            DetailsViewActions.parseExperimentAdvanceEffect(value.id, result2.getSuccessData(), void 0),
            loadAssignmentDetailsAction({
              workspaceId: ((_d = (_c = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _c.data) == null ? void 0 : _d.workspaceId) || "",
              experimentId: value.id
            })
          );
        }),
        catchError((error) => of(DetailsViewActions.parseExperimentAdvanceEffect(value.id, null, error)))
      );
    })
  );
};
const experimentAdvanceEpic = (action$, state$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.INIT_ADVANCE_EXP),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.advanceExperiment(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b, _c, _d;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.finishAdvanceExperiment(
                value.id,
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown error while advancing experiment"
              )
            );
          }
          return Observable.of(
            // @ts-ignore
            DetailsViewActions.finishAdvanceExperiment(value.id, null),
            DetailsViewActions.getOperationsStatus(value.id),
            loadAssignmentDetailsAction({
              workspaceId: ((_d = (_c = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _c.data) == null ? void 0 : _d.workspaceId) || "",
              experimentId: value.id
            })
          );
        }),
        catchError((error) => of(DetailsViewActions.finishAdvanceExperiment(value.id, error)))
      );
    })
  );
};
const experimentStopEpic = (action$, state$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.INIT_STOP_EXP),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.stopExperiment(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b, _c, _d, _e, _f;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.finishStopExperiment(
                value.id,
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown error while stopping experiment"
              )
            );
          }
          return Observable.of(
            // @ts-ignore
            DetailsViewActions.finishStopExperiment(value.id, null),
            DetailsViewActions.getOperationsStatus(value.id),
            loadQualityAlerts(
              value.id,
              EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER,
              ((_d = (_c = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _c.data) == null ? void 0 : _d.workspaceId) || ""
            ),
            loadAssignmentDetailsAction({
              workspaceId: ((_f = (_e = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _e.data) == null ? void 0 : _f.workspaceId) || "",
              experimentId: value.id
            })
          );
        }),
        catchError((error) => of(DetailsViewActions.finishStopExperiment(value.id, error)))
      );
    })
  );
};
const experimentHideEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.INIT_HIDE_EXP),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.deleteExperiment(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.finishHideExperiment(
                value.id,
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown error while deleting experiment"
              )
            );
          }
          return Observable.of(DetailsViewActions.finishHideExperiment(value.id, null));
        }),
        catchError((error) => of(DetailsViewActions.finishHideExperiment(value.id, error)))
      );
    })
  );
};
const experimentUnhideEpic = (action$, state$) => {
  return action$.pipe(
    // @ts-ignore
    ofType(detailsViewActionTypes.INIT_UNHIDE_EXP),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.unhideExperiment(value.id)).pipe(
        mergeMap((result2) => {
          var _a, _b, _c, _d;
          if (!result2.isSuccessful()) {
            return of(
              // @ts-ignore
              DetailsViewActions.finishUnhideExperiment(
                value.id,
                // @ts-ignore
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown error while unhiding experiment"
              )
            );
          }
          return Observable.of(
            DetailsViewActions.finishUnhideExperiment(value.id, void 0),
            loadAssignmentDetailsAction({
              workspaceId: ((_d = (_c = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _c.data) == null ? void 0 : _d.workspaceId) || "",
              experimentId: value.id
            })
          );
        }),
        // @ts-ignore
        catchError((error) => of(DetailsViewActions.finishUnhideExperiment(value.id, error)))
      );
    })
  );
};
const experimentEditDataEpic = (action$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.LOAD_EXP_EDIT_DATA),
    mergeMap(
      (value) => {
        const { id, isFeatureRollout } = value;
        const experimentationGroup = getExperimentationGroupIdFromPath(value.workspaceId, value.managementGroup);
        const getExpData = Observable.forkJoin(
          ExperimentResources.getExperimentEditRules(id),
          MdsDataplaneResources.getConfigWithType({
            workspaceId: value.workspaceId,
            experimentationGroup,
            section: MasterDataConstants.flightControlSection
          })
        ).map(([editRulesResult, flightControlResult]) => {
          var _a, _b;
          if (!editRulesResult.isSuccessful()) {
            return DetailsViewActions.loadedExperimentEditData(
              id,
              null,
              null,
              (_b = (_a = editRulesResult == null ? void 0 : editRulesResult.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown error while fetching experiment edit rules",
              editRulesResult
            );
          }
          const parsedRules = ExperimentUtilsInstance.parseExperimentEditRules(
            editRulesResult.getSuccessData(),
            isFeatureRollout
          );
          return DetailsViewActions.loadedExperimentEditData(id, parsedRules, flightControlResult, null, editRulesResult);
        }).catch((error) => {
          return of(DetailsViewActions.loadedExperimentEditData(id, null, null, error));
        });
        const act = DetailsViewActions.loadingExperimentEditData(id);
        return from([getExpData, from([act])]).pipe(mergeMap((x) => x));
      }
    )
  );
};
const experimentDetailsUpdateEpic = (action$, state$) => {
  return action$.pipe(
    ofType(detailsViewActionTypes.INIT_UPDATE_EXP_DETAILS),
    switchMap((value) => {
      return Observable.fromPromise(ExperimentResources.updateExperiment(value.id, value.update)).pipe(
        mergeMap((result2) => {
          var _a, _b, _c, _d, _e, _f;
          if (!result2.isSuccessful()) {
            return of(
              DetailsViewActions.finishUpdateExperiment(
                value.id,
                (_b = (_a = result2 == null ? void 0 : result2.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "Unknown Error while updating experiment"
              )
            );
          }
          return Observable.of(
            // @ts-ignore
            DetailsViewActions.finishUpdateExperiment(value.id, null),
            DetailsViewActions.getExperimentData(value.id),
            // reload data on success.
            DetailsViewActions.getOperationsStatus(value.id),
            /**
             * Note: We have actions that create duplicate API calls
             * because experiment and expalert are seperate App Modules that do not share state
             * both DetailsViewActions.getOperationsStatus() and loadOperationChecks() load operation checks
             */
            loadQualityAlerts(
              value.id,
              EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER,
              ((_d = (_c = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _c.data) == null ? void 0 : _d.workspaceId) || ""
            ),
            loadOperationChecks(value.id, EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER),
            loadAssignmentDetailsAction({
              workspaceId: ((_f = (_e = state$.value.currentUserDetails.userAffinity) == null ? void 0 : _e.data) == null ? void 0 : _f.workspaceId) || "",
              experimentId: value.id
            })
          );
        }),
        catchError((error) => of(DetailsViewActions.finishUpdateExperiment(value.id, error)))
      );
    })
  );
};
const detailsViewEpics = combineEpics(
  experimentDataEpic,
  loadExperiment,
  experimentScorecardEpic,
  experimentLogEpic,
  experimentIterationsEpic,
  experimentOperationsEpic,
  experimentStartEpic,
  experimentAdvanceDiffEpic,
  experimentAdvanceEpic,
  experimentStopEpic,
  experimentHideEpic,
  experimentUnhideEpic,
  experimentEditDataEpic,
  experimentDetailsUpdateEpic,
  experimentIterateEpic,
  finishIterateEpic,
  finishUpdateEpic
);
export {
  detailsViewEpics,
  experimentAdvanceDiffEpic,
  experimentAdvanceEpic,
  experimentDataEpic,
  experimentDetailsUpdateEpic,
  experimentEditDataEpic,
  experimentHideEpic,
  experimentIterateEpic,
  experimentIterationsEpic,
  experimentLogEpic,
  experimentOperationsEpic,
  experimentScorecardEpic,
  experimentStartEpic,
  experimentStopEpic,
  experimentUnhideEpic,
  finishIterateEpic,
  finishUpdateEpic,
  loadExperiment
};
//# sourceMappingURL=DetailsViewEpics.js.map
